import JSZip from 'jszip';
import { useState } from 'react';
import { styled } from 'styled-components';

import { DeviceList } from './components/device/DeviceList';
import { devices } from './devices';
import { GlobalStyles } from './GlobalStyles';

const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 32px 0 16px 0;
`;

const Title = styled.h1`
  padding: 12px 24px 16px 24px;
  color: #06490a;
  background-color: #d2e7d3;
  border-radius: 38px;
`;

const loadImage = async (src) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.src = src;

    image.onload = () => {
      resolve(image);
    };

    image.onerror = (error) => {
      reject(error);
    };

    image.onabort = (error) => {
      reject(error);
    };
  });

export const App = () => {
  const [imageFiles, setImageFiles] = useState([]);
  const [overlayFile, setOverlayFile] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleImageChange = (e) => {
    setImageFiles([...e.target.files]);
  };

  const handleOverlayChange = (e) => {
    setOverlayFile(e.target.value);
  };

  const processImages = async () => {
    if (!imageFiles.length || !overlayFile) {
      alert('Please select the image files and the overlay image.');

      return;
    }

    setIsProcessing(true);
    const overlay = await loadImage(`/devices/apple/${overlayFile}`);
    const zip = new JSZip();

    for (const file of imageFiles) {
      const image = await readFileAsImage(file);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = overlay.width;
      canvas.height = overlay.height;

      const posX = (overlay.width - image.width) / 2;
      const posY = (overlay.height - image.height) / 2;

      ctx.drawImage(image, posX, posY, image.width, image.height);
      ctx.drawImage(overlay, 0, 0, overlay.width, overlay.height);

      const dataURL = canvas.toDataURL('image/png');
      zip.file(file.name, dataURL.split(',')[1], { base64: true });
    }

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'overlay_images.zip');
      setIsProcessing(false);
    });
  };

  return (
    <div className="App">
      <GlobalStyles />
      <Header>
        <Title>shot.cool</Title>
      </Header>
      <DeviceList />
      <header className="App-header">
        <input type="file" onChange={handleImageChange} multiple accept="image/*" />
        <select onChange={handleOverlayChange}>
          {devices.apple.map((device) => (
            <option key={device} value={device}>
              {device}
            </option>
          ))}
        </select>
        <button onClick={processImages} disabled={isProcessing}>
          {isProcessing ? 'Processing...' : 'Process Images'}
        </button>
      </header>
    </div>
  );
};

async function readFileAsImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      const img = new Image();

      img.onload = () => {
        resolve(img);
      };

      img.src = event.target.result;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function saveAs(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}
